import type { CSSProperties } from 'react';
import { useId } from 'react';

import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type IconDragDotsProps = IconComponentBaseProps;

export const IconDragDots = ({
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[4],
  className,
}: IconDragDotsProps) => {
  const maskId = useId();

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask id={maskId} style={maskStyle} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M5.99968 13.0769C5.70357 13.0769 5.45007 12.9714 5.23918 12.7606C5.0283 12.5497 4.92285 12.2962 4.92285 12.0001C4.92285 11.7039 5.0283 11.4504 5.23918 11.2396C5.45007 11.0287 5.70357 10.9232 5.99968 10.9232C6.2958 10.9232 6.5493 11.0287 6.76018 11.2396C6.97107 11.4504 7.07652 11.7039 7.07652 12.0001C7.07652 12.2962 6.97107 12.5497 6.76018 12.7606C6.5493 12.9714 6.2958 13.0769 5.99968 13.0769ZM9.99968 13.0769C9.70357 13.0769 9.45007 12.9714 9.23918 12.7606C9.0283 12.5497 8.92285 12.2962 8.92285 12.0001C8.92285 11.7039 9.0283 11.4504 9.23918 11.2396C9.45007 11.0287 9.70357 10.9232 9.99968 10.9232C10.2958 10.9232 10.5493 11.0287 10.7602 11.2396C10.9711 11.4504 11.0765 11.7039 11.0765 12.0001C11.0765 12.2962 10.9711 12.5497 10.7602 12.7606C10.5493 12.9714 10.2958 13.0769 9.99968 13.0769ZM5.99968 9.07688C5.70357 9.07688 5.45007 8.97144 5.23918 8.76055C5.0283 8.54966 4.92285 8.29616 4.92285 8.00005C4.92285 7.70394 5.0283 7.45044 5.23918 7.23955C5.45007 7.02866 5.70357 6.92322 5.99968 6.92322C6.2958 6.92322 6.5493 7.02866 6.76018 7.23955C6.97107 7.45044 7.07652 7.70394 7.07652 8.00005C7.07652 8.29616 6.97107 8.54966 6.76018 8.76055C6.5493 8.97144 6.2958 9.07688 5.99968 9.07688ZM9.99968 9.07688C9.70357 9.07688 9.45007 8.97144 9.23918 8.76055C9.0283 8.54966 8.92285 8.29616 8.92285 8.00005C8.92285 7.70394 9.0283 7.45044 9.23918 7.23955C9.45007 7.02866 9.70357 6.92322 9.99968 6.92322C10.2958 6.92322 10.5493 7.02866 10.7602 7.23955C10.9711 7.45044 11.0765 7.70394 11.0765 8.00005C11.0765 8.29616 10.9711 8.54966 10.7602 8.76055C10.5493 8.97144 10.2958 9.07688 9.99968 9.07688ZM5.99968 5.07688C5.70357 5.07688 5.45007 4.97144 5.23918 4.76055C5.0283 4.54966 4.92285 4.29616 4.92285 4.00005C4.92285 3.70394 5.0283 3.45044 5.23918 3.23955C5.45007 3.02866 5.70357 2.92322 5.99968 2.92322C6.2958 2.92322 6.5493 3.02866 6.76018 3.23955C6.97107 3.45044 7.07652 3.70394 7.07652 4.00005C7.07652 4.29616 6.97107 4.54966 6.76018 4.76055C6.5493 4.97144 6.2958 5.07688 5.99968 5.07688ZM9.99968 5.07688C9.70357 5.07688 9.45007 4.97144 9.23918 4.76055C9.0283 4.54966 8.92285 4.29616 8.92285 4.00005C8.92285 3.70394 9.0283 3.45044 9.23918 3.23955C9.45007 3.02866 9.70357 2.92322 9.99968 2.92322C10.2958 2.92322 10.5493 3.02866 10.7602 3.23955C10.9711 3.45044 11.0765 3.70394 11.0765 4.00005C11.0765 4.29616 10.9711 4.54966 10.7602 4.76055C10.5493 4.97144 10.2958 5.07688 9.99968 5.07688Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

const maskStyle: CSSProperties = { maskType: 'alpha' };
